import * as Sentry from '@sentry/browser';

import siteConfig from '~/config';

Sentry
  .init({
    dsn: siteConfig.SENTRY_DSN,
    release: siteConfig.RELEASE_TAG,
    environment: siteConfig.ENVIRONMENT,
  });
